import WebViewer from '@pdftron/webviewer'
import {saveAnnotation} from '../dataSource/webViewer'

const webViewerDRSaveAnnotation = async (instance, fileCategory, fileSeq) => {
	const {annotManager} = instance

	if (instance === null) {
		console.error("Cannot get the WebViewer Instance!")
		return
	}

	return (
		annotManager.exportAnnotations({ links: false, widgets: false }).then(xfdfString => {
			return (
				saveAnnotation({
					file_ref: fileSeq,
					file_cat: fileCategory,
					annotation: xfdfString
				}).then(res => {
					console.log("*****************************************************************************")
					console.log("Annotation Save and Publish Successful")
					console.log(res)
					console.log("*****************************************************************************")

					return res
				})
			)
		})
	)
}


export {webViewerDRSaveAnnotation}